import { Link } from 'react-router-dom';
import { T } from '../styles/theme';

export default function NotFound() {
  return (
    <div style={{ minHeight: '100vh', background: T.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ width: 80, height: 80, background: 'rgba(124,58,237,0.1)', borderRadius: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
          <span style={{ fontFamily: T.fontDisplay, color: T.violet, fontSize: '2.5rem', fontWeight: 800 }}>404</span>
        </div>
        <h1 style={{ fontFamily: T.fontDisplay, fontSize: '1.6rem', fontWeight: 800, color: T.text, marginBottom: 8 }}>Pagina non trovata</h1>
        <p style={{ fontFamily: T.fontBody, color: T.muted, marginBottom: 24 }}>La pagina che cerchi non esiste.</p>
        <Link to="/dashboard" className="btn-primary">Torna alla Dashboard</Link>
      </div>
    </div>
  );
}
